import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";

// const API_BASE = "http://localhost/myapp/api/uploads";
const API_BASE = "https://spst.in/myapp/api/uploads";

// ---------------------
// Debounce Hook
// ---------------------
function useDebounced(value, delay = 250) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

function defaultRowKey(row, idx) {
  return row.id || row.key || idx;
}

// ---------------------
// Searchable + Paginated Table
// ---------------------
function SearchablePaginatedTable({
  data = [],
  columns = [],
  initialPageSize = 10,
  pageSizeOptions = [5, 10, 25, 50],
  globalSearch = true,
  searchPlaceholder = "Search...",
  rowKey = defaultRowKey,
}) {
  const [query, setQuery] = useState("");
  const debouncedQuery = useDebounced(query, 200);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [page, setPage] = useState(0);

  const filtered = useMemo(() => {
    if (!debouncedQuery) return data;
    const q = debouncedQuery.trim().toLowerCase();

    return data.filter((row) =>
      columns.some((col) => {
        const v =
          typeof col.accessor === "function"
            ? col.accessor(row)
            : row[col.accessor];
        return String(v || "").toLowerCase().includes(q);
      })
    );
  }, [data, debouncedQuery, columns]);

const pageCount =
  pageSize >= filtered.length ? 1 : Math.max(1, Math.ceil(filtered.length / pageSize));



  
  useEffect(() => {
    if (page >= pageCount) setPage(0);
  }, [pageCount, page]);

  const pageData = useMemo(() => {
    const start = page * pageSize;
    return filtered.slice(start, start + pageSize);
  }, [filtered, page, pageSize]);

  function goto(p) {
    const next = Math.max(0, Math.min(pageCount - 1, p));
    setPage(next);
  }

  return (
    <div className="w-full p-4  rounded shadow-sm text-black" style={{marginTop:'100px'}}>
      <p className="tenders">Tenders</p>
      <div className="mb-4 flex gap-3 items-center">
  <input
    value={query}
    onChange={(e) => setQuery(e.target.value)}
    placeholder={searchPlaceholder}
    className="px-3 py-2  rounded text-black" style={{border:'none',outline:'none',borderBottom:'1px solid silver',marginRight:'20px'}}
  />

  {/* Page Size Dropdown */}
  <select
    className="px-3 py-2 border rounded text-black"
    value={pageSize}
    onChange={(e) => {
      const val = e.target.value;
      if (val === "all") setPageSize(filtered.length || 1);
      else setPageSize(Number(val));
      setPage(0); // reset to first page
    }}
  >
    <option value={10}>10</option>
    <option value={20}>20</option>
    <option value={30}>30</option>
    <option value={40}>40</option>
    <option value={50}>50</option>
    {/* <option value="all">All</option> */}
  </select>
</div>


    <div class="row" style={{marginBottom:'50px'}}>
      <div className="col-md-12">
            <table className="w-full table-auto border-collapse text-black">
        <thead>
          {/* <tr className="border-b text-black">
            {columns.map((col) => (
              <th key={col.header} className="py-2 px-3 text-left text-black">
                {col.header}
              </th>
            ))}
          </tr> */}
        </thead>
        <tbody>
          {pageData.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="py-4 text-center text-black">
                No results
              </td>
            </tr>
          ) : (
            pageData.map((row, i) => (
              <tr
                key={rowKey(row, i)}
                className="border-b cursor-pointer hover:bg-gray-100 text-black"
                onClick={() =>
                  window.open(`myapp/${row.file_path}`)
                }
              >
                {columns.map((col) => (
                  <td key={col.header} className="py-2 px-3 text-black tenderlist" style={{border:'1px dotted maroon',boxShadow:'5px 5px 10px silver'}}>
                    
                    
                      {typeof col.accessor === "function"
                      ? col.accessor(row)
                      : row[col.accessor]}
                      
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
      </div>
      {/* <div class="col-md-4">
          <div> 
              <img src="./images/event.jpeg" alt="Padmanabhaswami Temple"  style={{width:'100%'}} />
          </div>
            
      </div> */}

    </div>
      

      {/* Pagination */}
      <div className="mt-4 flex justify-between text-black">
        <button onClick={() => goto(page - 1)} disabled={page === 0} className="btn btn-danger">
          Prev
        </button>
        <span style={{color:'black',paddingLeft:'15px',paddingRight:'15px'}}>
          Page {page + 1} of {pageCount}
        </span>
        <button
          onClick={() => goto(page + 1)}
          disabled={page >= pageCount - 1} className="btn btn-danger"
        >
          Next
        </button>
      </div>
    </div>
  );
}

// ---------------------
// Your NewsEvents Component
// ---------------------
function NewsEvents() {
  const [uploads, setUploads] = useState([]);

  useEffect(() => {
    fetchUploads();
  }, []);

  const fetchUploads = async () => {
    const res = await axios.get(`${API_BASE}/get.php`);
    setUploads(res.data);
  };

const columns = [
  {
    header: "",
    accessor: (row) => (
      <span style={{ fontSize: "20pt" }}>👉</span>
    ),
  },
  { header: "Name", accessor: "name" },
];


  return (
    <div className="container text-black">
      

      <SearchablePaginatedTable
        data={uploads}
        columns={columns}
        initialPageSize={10}
      />
    </div>
  );
}

export default NewsEvents;
